import { render, staticRenderFns } from "./ElementSlider.vue?vue&type=template&id=0b069551&scoped=true"
import script from "./ElementSlider.vue?vue&type=script&lang=js"
export * from "./ElementSlider.vue?vue&type=script&lang=js"
import style0 from "./ElementSlider.vue?vue&type=style&index=0&id=0b069551&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b069551",
  null
  
)

export default component.exports